import dayjs, { Dayjs } from 'dayjs';

export function isYearValid(year: string) {
  return year && !Number.isNaN(year) && /^\d{4}$/.test(year);
}

export function isMonthValid(month: string) {
  return month && !Number.isNaN(month) && /^[1-9]$|^1[0-2]$/.test(month);
}

export function isDateInZeitraum(
  date: dayjs.Dayjs,
  monthStart: dayjs.Dayjs,
  monthEnd: dayjs.Dayjs,
) {
  return (
    date.isSameOrAfter(monthStart, 'day') &&
    date.isSameOrBefore(monthEnd, 'day')
  );
}

export function getInformationForDay(day: Dayjs, month: number) {
  return {
    isInSelectedMonth: day.month() + 1 === month,
    isToday: day.isSame(dayjs(), 'day'),
    isMonday: day.day() === 1,
    calendarWeek: day.isoWeek(),
  };
}
